export enum SourceLayerEnum {
  API = 'API',
  DATA_SYNC = 'DATA_SYNC',
  API_EXPERIENCE = 'API_EXPERIENCE',
  API_PROCESS = 'API_PROCESS',
  API_SYSTEM = 'API_SYSTEM',
  DATA_SOURCE = 'DATA_SOURCE',
}

export enum LoginMode {
  FULL = 'full',
  LIGHT = 'light',
}

export enum NavigationRouteTypeEnum {
  PLAN_MY_CRUISE = 'PLAN_MY_CRUISE',
  CRUISE_PAYMENT = 'CRUISE_PAYMENT',
  PLUSGRADE = 'PLUSGRADE',
}

export enum BookingStatusEnum {
  QUOTE = 'QUOTE',
  OPTIONAL = 'OPTION',
  BOOKED = 'BOOKED',
  CANCELLED = 'CANCELLED',
  WAITLIST = 'WAITLIST',
  OWN_AIR = 'OWN_AIR',
  REFUND_REQUESTED = 'REFUND_REQUESTED',
}

export enum BookingChannelEnum {
  B2C = 'B2C',
  ONL = 'ONL',
  XML = 'XML',
  AM = 'AM',
  SB = 'SB',
  RES = 'RES',
}

export enum BookingPaymentMethodEnum {
  DIRECT = 'DIRECT',
  AGENCY = 'AGENCY',
}

export enum BookingTypeEnum {
  INDIVIDUAL = 'INDIVIDUAL',
  GROUP = 'GROUP',
}

export enum LevelEnum {
  PARENT = 'PARENT',
  CHILD = 'CHILD',
}

export enum ApplicabilityEnum {
  ALL = 'ALL',
  MANDATORY = 'MANDATORY',
  OPTIONAL = 'OPTIONAL',
  SUBSTITUTABLE = 'SUBSTITUTABLE',
}

export enum AgeCategoryEnum {
  SENIOR = 'SENIOR',
  ADULT = 'ADULT',
  CHILD = 'CHILD',
  JUNIOR = 'JUNIOR',
  INFANT = 'INFANT',
}

export enum GenderEnum {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
}

export enum IdentityDocumentTypeEnum {
  PASSPORT = 'PASSPORT',
  BIRTH_CERTIFICATE = 'BIRTH_CERTIFICATE',
  DRIVERS_LICENSE = 'DRIVERS_LICENSE',
  WORK_PERMIT = 'WORK_PERMIT',
  ATTORNEY_PERMIT = 'ATTORNEY_PERMIT',
  VISA = 'VISA',
  NATIONAL_IDENTITY = 'NATIONAL_IDENTITY',
}

export enum AllocationTypeEnum {
  INDIVIDUAL = 'INDIVIDUAL',
  GROUP = 'GROUP',
  DYNAMIC_BLOCK = 'DYNAMIC_BLOCK',
  AGENT_BLOCK = 'AGENT_BLOCK',
  OFFICE_BLOCK = 'OFFICE_BLOCK',
  DEFAULT = 'DEFAULT',
}

export enum availabilityStatusEnum {
  AVAILABLE = 'AVAILABLE',
  DENIED = 'DENIED',
  REQUESTED = 'REQUESTED',
  WAITING_LIST = 'WAITING_LIST',
}

export enum voyagersClubToggleOptionsEnum {
  ALREADY_MEMBER_TOGGLE = 'toggleOneOn',
  JOIN_CLUB_TOGGLE = 'toggleTwoOn',
  TOGGLESOFF = 'bothTogglesOFF',
}

export enum StepperWidgetTypeEnum {
  BOOKING_STATUS = 'BOOKING_STATUS',
  STATEROOM_STATUS = 'STATEROOM_STATUS',
  WCI_STATUS = 'WCI_STATUS',
  PAYMENT_STATUS = 'PAYMENT_STATUS',
}

export enum WebCheckInStatusEnum {
  COMPLETE = 'complete',
  INCOMPLETE = 'incomplete',
  UNAVAILABLE = 'unavailable',
}

export enum ItemTypeEnum {
  EXCURSION = 'EXCURSION',
  ONBOARD_SERVICE = 'ONBOARD_SERVICE',
}

export enum OBSTypesEnum {
  BEVERAGES = 'ALLINC',
  RESTAURANTS = 'FORFAI',
  SPA = 'SPA',
  PHOTO = 'PHOTO',
  BIRTHDAY = 'BIRTHD',
}

export enum TransactionStatusEnum {
  FULL = 'full',
  OPTIONAL = 'option',
  DEPOSIT = 'deposit',
}

export enum PaymentTypeEnum {
  DEPOSIT = 'DEPOSIT',
  FULL = 'FULL',
}

export enum LoginStatusAnalyticsEnum {
  FULL_LOGIN = 'full-login',
  LIGHT_LOGIN = 'light-login',
}

export enum LabelItemsTypeEnum {
  FLY = 'FLY',
  INSURANCE = 'INS',
  OBS = 'OBS',
  TRANSFER = 'TRF',
  HOTEL = 'HTL',
}

export enum WebCheckinDisabledStateLogic {
  DISABLE_CTA = 'disableButton',
  HIDE_COMPONENT = 'hideComponent',
}

// Enum for page type
export enum PageType {
  CART_PAGE = 'CART_PAGE',
  CHECKOUT_PAGE = 'CHECKOUT_PAGE',
  OTHER = 'OTHER',
}

export enum ECouponItemLevelReasonCode {
  COUPON_NOT_APPLICABLE = 'coupon_not_applicable',
  PROMOTION_ALREADY_APPLIED = 'promotion_already_applied',
}
